/** Utilidades de cor para rótulos escolhidos pelo usuário no colorpicker. */

const HEX = /^#([0-9a-f]{6})$/i

/** Normaliza para `#rrggbb`. Devolve null se não for um hex válido. */
export function normalizeHex(value: string | null | undefined): string | null {
  if (!value) return null
  const v = value.trim()
  const withHash = v.startsWith('#') ? v : `#${v}`
  // Aceita a forma curta (#abc) expandindo para a longa.
  const short = /^#([0-9a-f]{3})$/i.exec(withHash)
  if (short) {
    const [r, g, b] = short[1].split('')
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase()
  }
  return HEX.test(withHash) ? withHash.toLowerCase() : null
}

export function isHex(value: string | null | undefined): boolean {
  return normalizeHex(value) !== null
}

/**
 * Preto ou branco sobre a cor de fundo, pelo que tiver mais contraste.
 *
 * Usa luminância relativa (WCAG): sem isso um rótulo amarelo com texto branco
 * fica ilegível, que é justamente o risco de deixar a cor livre.
 */
export function readableTextColor(background: string): string {
  const hex = normalizeHex(background) ?? '#6b7280'
  const [r, g, b] = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16) / 255)
  const lin = (c: number) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4)
  const luminance = 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b)
  return luminance > 0.5 ? '#111827' : '#ffffff'
}

/** Mesma cor com transparência — para fundos suaves de chip. */
export function withAlpha(background: string, alpha: number): string {
  const hex = normalizeHex(background) ?? '#6b7280'
  const [r, g, b] = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16))
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
